import React from "react";
import css from "./TextView.module.css";


export default function TextView(props){
    const {text=props.children}=props;
    return (
        <div className={`${css.textview} ${props.className||""}`} style={props.style}>
            {text?.split("@").map((text,i)=>{
                text=text.trim();
                return <p
                    key={text[i]+i} 
                    dangerouslySetInnerHTML={{__html:text}}
                    sentence={[":",".","?"].some(c=>text.endsWith(c))?undefined:""}
                    ref={(element)=>{
                        const anchors=element?.querySelectorAll(":scope>a");
                        anchors?.forEach(anchor=>{
                            if(!anchor.target){anchor.target="_blank"};
                        });
                    }}
                />
            })}
        </div>
    )
}
